import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Contact.css';

const Contact = () => {
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    eventType: '',
    date: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const whatsappMsg = `Pershendetje Paradise Events!%0A%0AUne jam ${formData.name}.%0AEmail: ${formData.email}%0ATelefon: ${formData.phone}%0ALloji i eventit: ${formData.eventType}%0AData: ${formData.date}%0A%0A${formData.message}`;
    window.open(`https://wa.me/38349343079?text=${whatsappMsg}`, '_blank');
  };

  const fadeUp = (delay) => ({
    initial: { opacity: 0, y: 40 },
    animate: inView ? { opacity: 1, y: 0 } : {},
    transition: { delay, duration: 0.7, ease: [0.16, 1, 0.3, 1] },
  });

  return (
    <section className="contact section-padding" id="contact" ref={ref}>
      <div className="section-container">
        <div className="contact__grid">
          {/* Info side */}
          <div className="contact__info">
            <motion.span className="section-label" {...fadeUp(0)}>
              Kontakti
            </motion.span>
            <motion.h2 className="section-title" {...fadeUp(0.1)}>
              Le te planifikojme <em>eventin tuaj</em> se bashku
            </motion.h2>
            <motion.div className="gold-line" {...fadeUp(0.2)} />
            <motion.p className="contact__description" {...fadeUp(0.2)}>
              Na kontaktoni per nje konsulte falas. Ekipi yne eshte gati
              te degoje idete tuaja dhe te krijoje dicka te jashtezakonshme.
            </motion.p>

            <motion.div className="contact__details" {...fadeUp(0.3)}>
              <div className="contact__detail">
                <div className="contact__detail-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                  </svg>
                </div>
                <div>
                  <span className="contact__detail-label">Telefon</span>
                  <a href="tel:+38349343079" className="contact__detail-value">
                    +383 49 343 079
                  </a>
                </div>
              </div>

              <div className="contact__detail">
                <div className="contact__detail-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div>
                  <span className="contact__detail-label">Adresa</span>
                  <span className="contact__detail-value">
                    Rr. Enver Haradinaj, Pristina 10000
                  </span>
                </div>
              </div>

              <div className="contact__detail">
                <div className="contact__detail-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <rect x="2" y="2" width="20" height="20" rx="5" />
                    <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
                    <circle cx="17.5" cy="6.5" r="1.5" />
                  </svg>
                </div>
                <div>
                  <span className="contact__detail-label">Instagram</span>
                  <a
                    href="https://www.instagram.com/paradise.eventt/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact__detail-value contact__detail-value--link"
                  >
                    @paradise.eventt
                  </a>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Form side */}
          <motion.form
            className="contact__form"
            onSubmit={handleSubmit}
            {...fadeUp(0.3)}
          >
            <div className="contact__form-row">
              <div className="contact__field">
                <label className="contact__label">Emri juaj</label>
                <input
                  type="text"
                  name="name"
                  className="contact__input"
                  placeholder="Emri dhe Mbiemri"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="contact__field">
                <label className="contact__label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="contact__input"
                  placeholder="email@shembull.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="contact__form-row">
              <div className="contact__field">
                <label className="contact__label">Telefoni</label>
                <input
                  type="tel"
                  name="phone"
                  className="contact__input"
                  placeholder="+383 4X XXX XXX"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="contact__field">
                <label className="contact__label">Lloji i Eventit</label>
                <select
                  name="eventType"
                  className="contact__input contact__select"
                  value={formData.eventType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Zgjedhni...</option>
                  <option value="dasme">Dasme</option>
                  <option value="fejese">Fejese</option>
                  <option value="ditellindje">Ditellindje</option>
                  <option value="korporative">Event Korporativ</option>
                  <option value="tjeter">Tjeter</option>
                </select>
              </div>
            </div>

            <div className="contact__field">
              <label className="contact__label">Data e Eventit</label>
              <input
                type="date"
                name="date"
                className="contact__input"
                value={formData.date}
                onChange={handleChange}
              />
            </div>

            <div className="contact__field">
              <label className="contact__label">Mesazhi</label>
              <textarea
                name="message"
                className="contact__input contact__textarea"
                placeholder="Tregoni me shume per eventin tuaj..."
                rows="4"
                value={formData.message}
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="btn-primary contact__submit">
              <span>Dergo me WhatsApp</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </motion.form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
